import React from 'react';

/**
 * Pricing-tier cards. Supports two modes:
 * 1) Lunch/Dinner split (tier has `lunch` and `dinner` objects)
 * 2) Single price (tier has `singlePrice` number)
 */
const PricingTiers = ({ tiers }) => {
  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-5xl mx-auto mt-4 mb-12 px-4"
      data-testid="pricing-tiers"
    >
      {tiers.map((tier, i) => (
        <div
          key={i}
          className="relative rounded-2xl border-2 border-[#F5D06E] bg-[#3A1210]/50 shadow-[0_0_18px_rgba(245,208,110,0.15)] px-6 py-8 text-center flex flex-col items-center justify-center"
          data-testid={`pricing-tier-${i}`}
        >
          <h4
            className="text-[#F5D06E] font-bold uppercase tracking-wider text-sm sm:text-base mb-4 leading-tight"
            style={{ fontFamily: "'Akzidenz-Grotesk Next', 'Inter', sans-serif" }}
          >
            {tier.protein}
          </h4>

          {tier.singlePrice !== undefined ? (
            <p
              className="text-[#F5E6C9] font-bold text-xl sm:text-2xl"
              style={{ fontFamily: "'Akzidenz-Grotesk Next', 'Inter', sans-serif" }}
            >
              ${tier.singlePrice}
            </p>
          ) : (
            <div className="space-y-3 text-[#F5E6C9]">
              <div>
                <p className="text-sm sm:text-base">
                  Lunch <span className="text-[#F5D06E] font-bold">${tier.lunch.price}</span>
                  {tier.lunch.note && (
                    <span className="text-[#F5E6C9]/80"> ({tier.lunch.note})</span>
                  )}
                </p>
                {tier.lunch.detail && (
                  <p className="text-[#F5E6C9]/70 italic text-xs mt-1">({tier.lunch.detail})</p>
                )}
              </div>
              <p className="text-sm sm:text-base">
                Dinner <span className="text-[#F5D06E] font-bold">${tier.dinner.price}</span>
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PricingTiers;
